/**
 * Returns a string with all S3 unsafe characters replaced with a dash (-)
 * @param dirtyFileName
 * @returns {*}
 */
export default function(dirtyFileName) {
  // handle any special characters that might be in the file name
  // ref: https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingMetadata.html#object-key-guidelines
  return dirtyFileName.replace(/[&$@=;:+,?^{}%`\]">~<#|]/g, '-')
}
